module.exports = __webpack_public_path__ + "static/media/Icon-05@2x.e24f95ac.png";